import { render, staticRenderFns } from "./MainSceneItem.vue?vue&type=template&id=06a6612b&scoped=true"
import script from "./MainSceneItem.vue?vue&type=script&lang=js"
export * from "./MainSceneItem.vue?vue&type=script&lang=js"
import style0 from "./MainSceneItem.vue?vue&type=style&index=0&id=06a6612b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6612b",
  null
  
)

export default component.exports